import React from 'react';
import { TemplateBlock } from '../../../../../types/offerTemplate.types';
import HeadingBlockRenderer from './HeadingBlockRenderer';
import ParagraphBlockRenderer from './ParagraphBlockRenderer';
import QuoteBlockRenderer from './QuoteBlockRenderer';
import StatGridBlockRenderer from './StatGridBlockRenderer';
import ServiceGridBlockRenderer from './ServiceGridBlockRenderer';
import ImageBlockRenderer from './ImageBlockRenderer';
import DividerBlockRenderer from './DividerBlockRenderer';
import SpacerBlockRenderer from './SpacerBlockRenderer';
import GreetingBlockRenderer from './GreetingBlockRenderer';
import CustomerInfoBlockRenderer from './CustomerInfoBlockRenderer';
import ItemsTableBlockRenderer from './ItemsTableBlockRenderer';
import TotalsBlockRenderer from './TotalsBlockRenderer';
import TermsBlockRenderer from './TermsBlockRenderer';
import BankAccountsBlockRenderer from './BankAccountsBlockRenderer';
import SignatureBlockRenderer from './SignatureBlockRenderer';
import FooterBlockRenderer from './FooterBlockRenderer';

export interface BlockRendererFactoryProps {
  block: TemplateBlock;
  config: any;
  offer?: any;
  offerType?: 'given' | 'received';
  companyInfo?: any;
}

const BlockRendererFactory: React.FC<BlockRendererFactoryProps> = ({
  block,
  config,
  offer,
  offerType,
  companyInfo,
}) => {
  switch (block.type) {
    case 'heading':
      return <HeadingBlockRenderer block={block} config={config} />;
    case 'paragraph':
      return <ParagraphBlockRenderer block={block} config={config} />;
    case 'quote':
      return <QuoteBlockRenderer block={block} config={config} />;
    case 'statGrid':
      return <StatGridBlockRenderer block={block} config={config} />;
    case 'serviceGrid':
      return <ServiceGridBlockRenderer block={block} config={config} />;
    case 'image':
      return <ImageBlockRenderer block={block} config={config} />;
    case 'divider':
      return <DividerBlockRenderer block={block} config={config} />;
    case 'spacer':
      return <SpacerBlockRenderer block={block} config={config} />;
    case 'greeting':
      return <GreetingBlockRenderer block={block} config={config} offer={offer} />;
    case 'customerInfo':
      return (
        <CustomerInfoBlockRenderer
          block={block}
          config={config}
          offer={offer}
          offerType={offerType}
        />
      );
    case 'itemsTable':
      return <ItemsTableBlockRenderer block={block} config={config} offer={offer} />;
    case 'totals':
      return (
        <TotalsBlockRenderer
          block={block}
          config={config}
          offer={offer}
          offerType={offerType}
        />
      );
    case 'terms':
      return <TermsBlockRenderer block={block} config={config} offer={offer} />;
    case 'bankAccounts':
      return <BankAccountsBlockRenderer block={block} config={config} companyInfo={companyInfo} />;
    case 'signature':
      return <SignatureBlockRenderer block={block} config={config} />;
    case 'footer':
      return <FooterBlockRenderer block={block} config={config} companyInfo={companyInfo} />;
    default:
      return null;
  }
};

export default BlockRendererFactory;
